import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Checkbox,
  DatePicker,
  Input,
  InputNumber,
  message,
  Radio,
  Select,
  Space,
  Tag,
} from "antd";
import { BackIcon, UploadIcon } from "../../../../asset";
import { t } from "i18next";
import style from "./vehiclePage.module.css";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import { useNavigate, useLocation } from "react-router";
import { ROUTES } from "../../../../constant/routeConstant";
import TextArea from "antd/es/input/TextArea";
import Dragger from "../../../../component/dragger/Dragger";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import { useVehicle } from "./VehiclePage.hooks";
import SuccessModal from "../../../../component/modal/SuccessModal";
import ModalConfirmLeave from "../../../../component/modal/ModalConfirmLeave";
import moment from "moment";
import dayjs from "dayjs";
import SelectSearch from "../../../../component/input/SelectSearch";
import { InformationIcon } from "../../../../asset/icons";

export default function VehicleEdit() {
  const _ = require("lodash");
  const { state } = useLocation();

  const {
    depotId,
    ownership,
    ownerName,
    vehicleType,
    skillSet,
    temperatureCategory,
    vehicleBrand,
    vehicleModel,
    vehicleNo,
    vehicleNoExpDate,
    vehicleWeight,
    chassisNo,
    engineNo,
    manufacturerYear,
    pucNo,
    insuranceNo,
    accidentHistory,
    minOrderUnit,
    maxOrderUnit,
    minOrderWeight,
    maxOrderWeight,
    minOrderVolume,
    maxOrderVolume,
    fixedCost,
    variableCost,
    transporterTimeCost,
    waitingTimeCost,
    loadingTime,
    additionalProofValues,
    onChange,
    setVehicleNumberImage,
    setVehiclePucImage,
    setVehicleInsuranceImage,
    vehicleNumberImage,
    vehiclePucImage,
    vehicleInsuranceImage,
    skillsetList,
    temperatureCategoryList,
    setTemperatureCategory,
    doPostVehicle,
    successModalOpen,
    navigate,
    skillsetError,
    temperatureCategoryError,
    plateError,
    plateExpError,
    vehicleWeightError,
    minOrderUnitError,
    maxOrderUnitError,
    minOrderWeightError,
    maxOrderWeightError,
    minOrderVolumeError,
    maxOrderVolumeError,
    minMoreThanMaxOrderUnitError,
    maxLessThanMinOrderUnitError,
    minMoreThanMaxOrderWeightError,
    maxLessThanMinOrderWeightError,
    minMoreThanMaxOrderVolumeError,
    maxLessThanMinOrderVolumeError,
    fixedCostError,
    ownerNameError,
    setSkillsetError,
    setTemperatureCategoryError,
    setPlateError,
    setPlateExpError,
    setVehicleWeightError,
    setMinOrderUnitError,
    setMaxOrderUnitError,
    setMinOrderWeightError,
    setMaxOrderWeightError,
    setMinOrderVolumeError,
    setMaxOrderVolumeError,
    setMinMoreThanMaxOrderUnitError,
    setMaxLessThanMinOrderUnitError,
    setMinMoreThanMaxOrderWeightError,
    setMaxLessThanMinOrderWeightError,
    setMinMoreThanMaxOrderVolumeError,
    setMaxLessThanMinOrderVolumeError,
    setFixedCostError,
    setOwnerNameError,
    showConfirm,
    setShowConfirm,
    doGetListSkillset,
    setMinOrderWeight,
    doGetDetailVehicle,
    selectedOptions,
    setSelectedOptions,
    selectedSkillsetId,
    setSelectedSkillsetId,
    vehicleDetail,
    isDetailLoaded,
    toVehicleList,
    doEditVehicle,
    checkIsEdited,
    additionalProofEditOnChange,
    combinedAdditionalProof,
    doGetMaxOrderUnit,
    maxOrder,
    parameterError,
    maxOrderRef,
    onScroll,
    skillsetKeyword,
    onSearchDDS,
    temperatureCategoryKeyword,
    checkForm,
  } = useVehicle();

  const handleChange = (value) => {
    setSelectedSkillsetId([value]);
    onChange("skillset", selectedOptions);
  };

  useEffect(() => {
    doGetListSkillset(1, skillsetKeyword, "list", state.depot_id);
    doGetMaxOrderUnit();
    doGetDetailVehicle(state.id);
  }, []);

  const [isInfoOpened, setIsInfoOpened] = useState(false);

  const handleSubmit = (data) => {
    const formData = new FormData();

    // if (checkForm()) {
      console.log("sini");
      if (
        (data.ownership !== ""|| ownership !== "") &&
        data.skill_set_id.length !== 0 &&
        data.temperature_category_id !== null &&
        data.vehicle_no !== "" &&
        (data.max_order_unit !== 0|| maxOrderUnit !== 0) &&
        (data.max_order_weight !== 0||maxOrderWeight !== 0) &&
        (data.max_order_volume !== 0||maxOrderVolume !== 0) &&
        (data.fixed_cost !== 0||fixedCost !== "") &&
        data.vehicle_no_exp_date !== "" &&
        (data.vehicle_weight !== 0||vehicleWeight !== "") &&
        (data.min_order_unit <= data.max_order_unit || minOrderUnit <= maxOrderUnit) &&
        (data.min_order_volume <= data.max_order_volume || minOrderVolume <= maxOrderVolume) &&
        (data.min_order_weight <= data.max_order_weight || minOrderWeight <= maxOrderWeight)
      ) {
        console.log("sini2");
        if (data.ownership !== "Y") {
          if (data.owner_name !== "") {
            const content = {
              depot_id: data.depot_id,
              ownership: ownership ? ownership : data.ownership,
              owner_name: ownerName ? ownerName : data.owner_name,
              vehicle_type: vehicleType ? vehicleType : data.vehicle_type,
              skill_set: {
                skill_set_id: selectedSkillsetId
                  ? selectedSkillsetId
                  : data.skill_set_id,
              },
              temperature_category_id: temperatureCategory
                ? temperatureCategory
                : data.temperature_category_id,
              vehicle_brand: vehicleBrand ? vehicleBrand : data.vehicle_brand,
              vehicle_model: vehicleModel ? vehicleModel : data.vehicle_model,
              vehicle_no:
                vehicleNo.length === 3 ? vehicleNo.join("-") : data.vehicle_no,
              vehicle_no_exp_date: vehicleNoExpDate
                ? vehicleNoExpDate
                : data.vehicle_no_exp_date,
              vehicle_weight: vehicleWeight
                ? vehicleWeight
                : data.vehicle_weight,
              chassis_no: chassisNo ? chassisNo : data.chassis_no,
              engine_no: engineNo ? engineNo : data.engine_no,
              manufacture_year: manufacturerYear
                ? manufacturerYear
                : data.manufacture_year,
              puc_no: pucNo ? pucNo : data.puc_no,
              insurance_no: insuranceNo ? insuranceNo : data.insurance_no,
              accident_history: accidentHistory
                ? accidentHistory
                : data.accident_history,
              min_order_unit: minOrderUnit ? minOrderUnit : data.min_order_unit,
              max_order_unit: maxOrderUnit ? maxOrderUnit : data.max_order_unit,
              min_order_weight: minOrderWeight
                ? minOrderWeight
                : data.min_order_weight,
              max_order_weight: maxOrderWeight
                ? maxOrderWeight
                : data.max_order_weight,
              min_order_volume: minOrderVolume
                ? minOrderVolume
                : data.min_order_volume,
              max_order_volume: maxOrderVolume
                ? maxOrderVolume
                : data.max_order_volume,
              fixed_cost: fixedCost ? fixedCost : data.fixed_cost,
              variable_cost: variableCost ? variableCost : data.variable_cost,
              transporter_time_cost: transporterTimeCost
                ? transporterTimeCost
                : data.transporter_time_cost,
              waiting_time_cost: waitingTimeCost
                ? waitingTimeCost
                : data.waiting_time_cost,
              loading_time: loadingTime ? loadingTime : data.loading_time,
              updated_at: data.updated_at,
            };

            if (combinedAdditionalProof.length !== 0) {
              content.additional_proofs_values = combinedAdditionalProof;
            }

            if (
              (typeof vehiclePucImage === "string" && vehiclePucImage !== "") ||
              (typeof vehiclePucImage === "object" &&
                vehiclePucImage.length !== 0)
            ) {
              content.puc_image = vehiclePucImage;
            }

            if (
              (typeof vehicleNumberImage === "string" &&
                vehicleNumberImage !== "") ||
              (typeof vehicleNumberImage === "object" &&
                vehicleNumberImage.length !== 0)
            ) {
              content.vehicle_no_image = vehicleNumberImage;
            }

            if (
              (typeof vehicleInsuranceImage === "string" &&
                vehicleInsuranceImage !== "") ||
              (typeof vehicleInsuranceImage === "object" &&
                vehicleInsuranceImage.length !== 0)
            ) {
              content.insurance_image = vehicleInsuranceImage;
            }

            formData.append("vehicle", JSON.stringify(content));
          } else {
            setOwnerNameError(true);
          }
        } else {
          const content = {
            depot_id: data.depot_id,
            ownership: ownership ? ownership : data.ownership,
            owner_name: data.owner_name,
            vehicle_type: vehicleType ? vehicleType : data.vehicle_type,
            skill_set: {
              skill_set_id: selectedSkillsetId
                ? selectedSkillsetId
                : data.skill_set_id,
            },
            temperature_category_id: temperatureCategory
              ? temperatureCategory
              : data.temperature_category_id,
            vehicle_brand: vehicleBrand ? vehicleBrand : data.vehicle_brand,
            vehicle_model: vehicleModel ? vehicleModel : data.vehicle_model,
            vehicle_no:
              vehicleNo.length === 3 ? vehicleNo.join("-") : data.vehicle_no,
            vehicle_no_exp_date: vehicleNoExpDate
              ? vehicleNoExpDate
              : data.vehicle_no_exp_date,
            vehicle_weight: vehicleWeight ? vehicleWeight : data.vehicle_weight,
            chassis_no: chassisNo ? chassisNo : data.chassis_no,
            engine_no: engineNo ? engineNo : data.engine_no,
            manufacture_year: manufacturerYear
              ? manufacturerYear
              : data.manufacture_year,
            puc_no: pucNo ? pucNo : data.puc_no,
            insurance_no: insuranceNo ? insuranceNo : data.insurance_no,
            accident_history: accidentHistory
              ? accidentHistory
              : data.accident_history,
            min_order_unit:
              minOrderUnit || minOrderUnit === 0
                ? minOrderUnit
                : data.min_order_unit,
            max_order_unit: maxOrderUnit ? maxOrderUnit : data.max_order_unit,
            min_order_weight:
              minOrderWeight || minOrderWeight === 0
                ? minOrderWeight
                : data.min_order_weight,
            max_order_weight: maxOrderWeight
              ? maxOrderWeight
              : data.max_order_weight,
            min_order_volume:
              minOrderVolume || minOrderVolume === 0
                ? minOrderVolume
                : data.min_order_volume,
            max_order_volume: maxOrderVolume
              ? maxOrderVolume
              : data.max_order_volume,
            fixed_cost: fixedCost ? fixedCost : data.fixed_cost,
            variable_cost: variableCost ? variableCost : data.variable_cost,
            transporter_time_cost: transporterTimeCost
              ? transporterTimeCost
              : data.transporter_time_cost,
            waiting_time_cost: waitingTimeCost
              ? waitingTimeCost
              : data.waiting_time_cost,
            loading_time: loadingTime ? loadingTime : data.loading_time,
            updated_at: data.updated_at,
          };

          if (combinedAdditionalProof.length !== 0) {
            content.additional_proofs_values = combinedAdditionalProof;
          }

          if (typeof vehiclePucImage === "string" && vehiclePucImage !== "") {
            content.puc_image = vehiclePucImage;
          }

          if (
            typeof vehicleNumberImage === "string" &&
            vehicleNumberImage !== ""
          ) {
            content.vehicle_no_image = vehicleNumberImage;
          }

          if (
            typeof vehicleInsuranceImage === "string" &&
            vehicleInsuranceImage !== ""
          ) {
            content.insurance_image = vehicleInsuranceImage;
          }

          formData.append("vehicle", JSON.stringify(content));
        }

        if (
          typeof vehicleNumberImage === "object" &&
          vehicleNumberImage.length !== 0
        ) {
          formData.append(
            "vehicle_no_photo",
            vehicleNumberImage[0].originFileObj
          );
        }
        if (
          typeof vehiclePucImage === "object" &&
          vehiclePucImage.length !== 0
        ) {
          formData.append(
            "vehicle_puc_photo",
            vehiclePucImage[0].originFileObj
          );
        }
        if (
          typeof vehicleInsuranceImage === "object" &&
          vehicleInsuranceImage.length !== 0
        ) {
          formData.append(
            "vehicle_insurance_photo",
            vehicleInsuranceImage[0].originFileObj
          );
        }

        doEditVehicle(formData, data.vehicle_id);
      } else {
        if (ownerName === "" && data.owner_name === "") {
          setOwnerNameError(true);
        }
        if (skillSet === "" && data.skill_set_id.length === 0) {
          setSkillsetError(true);
        }
        if (
          temperatureCategory === "" &&
          data.temperature_category_id === null
        ) {
          setTemperatureCategoryError(true);
        }
        if (vehicleNo.length !== 3 && data.vehicle_no === "") {
          setPlateError(true);
        }
        if (minOrderUnit === "" && data.min_order_unit === "") {
          setMinOrderUnitError(true);
        }
        if (maxOrderUnit === "" && data.max_order_unit === "") {
          setMaxOrderUnitError(true);
        }
        if (minOrderUnit > maxOrderUnit) {
          setMinMoreThanMaxOrderUnitError(true);
          setMaxLessThanMinOrderUnitError(true);
        }
        if (minOrderWeight === "" && data.min_order_weight === "") {
          setMinOrderWeightError(true);
        }
        if (maxOrderWeight === "" && data.max_order_weight === "") {
          setMaxOrderWeightError(true);
        }
        if (minOrderWeight > maxOrderWeight) {
          setMinMoreThanMaxOrderWeightError(true);
          setMaxLessThanMinOrderWeightError(true);
        }
        if (minOrderVolume === "" && data.min_order_volume === "") {
          setMinOrderVolumeError(true);
        }
        if (maxOrderVolume === "" && data.max_order_volume) {
          setMaxOrderVolumeError(true);
        }
        if (minOrderVolume > maxOrderVolume) {
          setMinMoreThanMaxOrderVolumeError(true);
          setMaxLessThanMinOrderVolumeError(true);
        }
        if (fixedCost === 0 && data.fixed_cost === 0) {
          setFixedCostError(true);
        }
        if (vehicleNoExpDate === "" && data.vehicle_no_exp_date === "") {
          setPlateExpError(true);
        }
        if (vehicleWeight === 0 && data.vehicle_weight === 0) {
          setVehicleWeightError(true);
        }
      }
    // }
  };

  return (
    <div>
      {isDetailLoaded ? (
        <div className="p-[24px] flex flex-col gap-[24px]">
          <ModalConfirmLeave
            visible={showConfirm}
            action={() => setShowConfirm(false)}
            route={ROUTES.VEHICLE.LIST}
          />

          <SuccessModal
            isOpen={successModalOpen}
            onOk={() => navigate(ROUTES.VEHICLE.LIST)}
            closable={false}
            width={280}
            className={style.successModal}
            okText="Go to Homepage"
            title="Well Done"
            description={<p>Your data has been updated</p>}
          />

          <Breadcumbs
            jmlLevel={4}
            menuLevel1={`Master`}
            menuLevel2={`Fleet`}
            menuLevel3={`Vehicle`}
            menuLevel4={`Edit ${vehicleDetail?.vehicle_id} - ${
              vehicleDetail?.vehicle_type
            } - ${
              vehicleDetail ? vehicleDetail.vehicle_no.replaceAll("-", " ") : ""
            }`}
          />

          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => checkIsEdited()}
          >
            <div className="flex items-center gap-[22px]">
              <img src={BackIcon} alt="" />
              <h1 className="font-sans-bold text-2xl" id="title">{`${t(
                "VEHICLE_EDIT:TITLE"
              )} ${vehicleDetail?.vehicle_id} - ${
                vehicleDetail?.vehicle_type
              } - ${
                vehicleDetail
                  ? vehicleDetail.vehicle_no.replaceAll("-", " ")
                  : ""
              }`}</h1>
            </div>
          </div>

          <div
            className={
              style.tabsContainer +
              " bg-[#FFFFFF] border-[1px] border-[#DDDDDD] px-[30px] py-[24px] rounded-[10px]"
            }
          >
            <div className="flex flex-row gap-[200px]">
              <div className="flex flex-col gap-[16px]">
                <h3 className="font-roboto text-[18px] font-[500]">
                  {t("VEHICLE_EDIT:VEHICLE_SPECIFICATION")}
                </h3>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:VEHICLE_OWNERSHIP_FIELD")}
                  </label>
                  <Input
                    className="mt-[8px]"
                    defaultValue={
                      vehicleDetail?.ownership === "Y"
                        ? "Owned"
                        : "Rent/Outsource"
                    }
                    disabled
                  />
                </div>

                {vehicleDetail?.ownership === "Y" ? (
                  ""
                ) : (
                  <div className="w-[350px] flex flex-col gap-[8px]">
                    <label className="font-[500] text-[16px] text-[#000000]">
                      {t("VEHICLE_ADD:VEHICLE_OWNER_FIELD")}{" "}
                      <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                    </label>
                    <Input
                      className="mt-[8px]"
                      maxLength={100}
                      style={
                        ownerNameError
                          ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                          : {}
                      }
                      placeholder={t("VEHICLE_ADD:VEHICLE_OWNER_PLACEHOLDER")}
                      onChange={(event) =>
                        onChange("vehicleOwner", event.target.value)
                      }
                      defaultValue={vehicleDetail?.owner_name}
                    />
                    <p
                      className={`font-[12px] text-[#FF0000] font-roboto ${
                        ownerNameError ? `visible` : `hidden`
                      }`}
                    >
                      This field is required
                    </p>
                  </div>
                )}

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:VEHICLE_TYPE_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <Input
                    className="mt-[8px]"
                    placeholder={t("VEHICLE_EDIT:VEHICLE_TYPE_PLACEHOLDER")}
                    defaultValue={vehicleDetail?.vehicle_type}
                    onChange={(event) =>
                      onChange("vehicleType", event.target.value)
                    }
                  />
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:SKILL_SET_FIELD")}
                  </label>
                  {/* <SelectSearch onSelect={(value) => handleChange(value)} style={style} status={skillsetError ? 'error' : null} data={skillsetOption} placeholder={"Select Skillset"} defaultValue={vehicleDetail?.skill_set_id[0]} /> */}

                  {skillsetList?.length !== 0 ? (
                    <SelectSearch
                      status={skillsetError ? "error" : ""}
                      onScroll={(event) =>
                        onScroll(event, "skillsetList", state.depot_id)
                      }
                      keyword={skillsetKeyword}
                      onChange={(value) =>
                        onSearchDDS(value, "skillsetList", state.depot_id)
                      }
                      onSelect={(value) => handleChange(value)}
                      width={350}
                      options={skillsetList}
                      placeholder={"Select Skillset"}
                      defaultValue={vehicleDetail?.skill_set_id[0]}
                    />
                  ) : null}

                  <p
                    className={`font-[12px] text-[#FF0000] font-roboto ${
                      skillsetError ? `visible` : `hidden`
                    }`}
                  >
                    This field is required
                  </p>
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:TEMPERATURE_CATEGORY_ID_FIELD")}
                  </label>
                  {/* <SelectSearch onSelect={(value) => onChange('temperatureCategory', value)} style={style} status={temperatureCategoryError ? 'error' : null} data={temperatureOption} placeholder={"Select Temperature Category"} defaultValue={vehicleDetail?.temperature_category_id} /> */}
                  {temperatureCategoryList?.length !== 0 ? (
                    <SelectSearch
                      status={temperatureCategoryError ? "error" : ""}
                      onScroll={(event) =>
                        onScroll(event, "temperatureCategoryList")
                      }
                      keyword={temperatureCategoryKeyword}
                      onChange={(value) =>
                        onSearchDDS(value, "temperatureCategoryList")
                      }
                      onSelect={(value) =>
                        onChange("temperatureCategory", value)
                      }
                      width={350}
                      options={temperatureCategoryList}
                      placeholder={"Select Temperature Category"}
                      defaultValue={vehicleDetail?.temperature_category_id}
                    />
                  ) : null}
                  <p
                    className={`font-[12px] text-[#FF0000] font-roboto ${
                      temperatureCategoryError ? `visible` : `hidden`
                    }`}
                  >
                    This field is required
                  </p>
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:VEHICLE_BRAND_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <Input
                    className="mt-[8px]"
                    placeholder={t("VEHICLE_EDIT:VEHICLE_BRAND_PLACEHOLDER")}
                    defaultValue={vehicleDetail?.vehicle_brand}
                    onChange={(event) =>
                      onChange("vehicleBrand", event.target.value)
                    }
                  />
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:VEHICLE_MODEL_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <Input
                    className="mt-[8px]"
                    placeholder={t("VEHICLE_EDIT:VEHICLE_MODEL_PLACEHOLDER")}
                    defaultValue={vehicleDetail?.vehicle_model}
                    onChange={(event) =>
                      onChange("vehicleModel", event.target.value)
                    }
                  />
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:LICENCE_PLATE_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <div className="flex gap-[8px]">
                    <Input
                      className="mt-[8px] w-[47px] text-center"
                      maxLength={1}
                      style={
                        plateError
                          ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                          : {}
                      }
                      placeholder="X"
                      defaultValue={vehicleNo[0]}
                      onChange={(event) =>
                        onChange("plate1", event.target.value)
                      }
                    />
                    <InputNumber
                      controls={false}
                      type="number"
                      className="mt-[8px] w-[78px] text-center"
                      style={
                        plateError
                          ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                          : {}
                      }
                      maxLength={4}
                      placeholder="1234"
                      defaultValue={vehicleNo[1]}
                      onChange={(event) => onChange("plate2", event)}
                    />
                    <Input
                      className="mt-[8px] w-[71px] text-center"
                      maxLength={3}
                      placeholder="ABC"
                      style={
                        plateError
                          ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                          : {}
                      }
                      defaultValue={vehicleNo[2]}
                      onChange={(event) =>
                        onChange("plate3", event.target.value)
                      }
                    />
                  </div>
                  <p
                    className={`font-[12px] text-[#FF0000] font-roboto ${
                      plateError ? `visible` : `hidden`
                    }`}
                  >
                    This field is required
                  </p>
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:LICENCE_PLATE_EXPIRED_FIELD")}
                  </label>
                  <DatePicker
                    placeholder={t(
                      "VEHICLE_EDIT:LICENCE_PLATE_EXPIRED_PLACEHOLDER"
                    )}
                    style={
                      plateExpError
                        ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                        : {}
                    }
                    format={"DD MMMM YYYY"}
                    onChange={(date, dateString) =>
                      onChange("licencePlateExpired", dateString)
                    }
                    defaultValue={dayjs(
                      vehicleDetail?.vehicle_no_exp_date,
                      "YYYY-MM-DD"
                    )}
                  />
                  <p
                    className={`font-[12px] text-[#FF0000] font-roboto ${
                      plateExpError ? `visible` : `hidden`
                    }`}
                  >
                    This field is required
                  </p>
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:VEHICLE_WEIGHT_FIELD")}
                  </label>
                  <InputNumber
                    min="0"
                    defaultValue={vehicleDetail?.vehicle_weight}
                    style={
                      vehicleWeightError
                        ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                        : {}
                    }
                    controls={false}
                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    onChange={(event) => onChange("vehicleWeight", event)}
                    className="w-[350px]"
                    placeholder="5.000.000"
                    addonAfter={<div className="text-[#818181]">Kg</div>}
                  />
                  <p
                    className={`font-[12px] text-[#FF0000] font-roboto ${
                      vehicleWeightError ? `visible` : `hidden`
                    }`}
                  >
                    This field is required
                  </p>
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:VEHICLE_CHASIS_NUMBER_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <Input
                    className="mt-[8px]"
                    placeholder={t(
                      "VEHICLE_EDIT:VEHICLE_CHASIS_NUMBER_PLACEHOLDER"
                    )}
                    defaultValue={vehicleDetail?.chassis_no}
                    onChange={(event) =>
                      onChange("vehicleChassisNo", event.target.value)
                    }
                  />
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:VEHICLE_ENGINE_NUMBER_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <Input
                    className="mt-[8px] w-[350px]"
                    maxLength={30}
                    controls={false}
                    placeholder={t(
                      "VEHICLE_EDIT:VEHICLE_ENGINE_NUMBER_PLACEHOLDER"
                    )}
                    defaultValue={vehicleDetail?.engine_no}
                    onChange={(event) =>
                      onChange("vehicleEngineNo", event.target.value)
                    }
                  />
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:MANUFACTURE_YEAR_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <DatePicker
                    placeholder={t("VEHICLE_EDIT:MANUFACTURE_YEAR_PLACEHOLDER")}
                    picker="year"
                    defaultValue={dayjs().year(vehicleDetail?.manufacture_year)}
                    onChange={(date, dateString) =>
                      onChange("manufactureYear", dateString)
                    }
                  />
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:PUC_NUMBER_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <Input
                    className="mt-[8px]"
                    placeholder={t("VEHICLE_EDIT:PUC_NUMBER_PLACEHOLDER")}
                    defaultValue={vehicleDetail?.puc_no}
                    onChange={(event) => onChange("pucNo", event.target.value)}
                  />
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:VEHICLE_INSURANCE_NUMBER_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <Input
                    className="mt-[8px]"
                    placeholder={t(
                      "VEHICLE_EDIT:VEHICLE_INSURANCE_NUMBER_PLACEHOLDER"
                    )}
                    defaultValue={vehicleDetail?.insurance_no}
                    onChange={(event) =>
                      onChange("vehicleInsuranceNo", event.target.value)
                    }
                  />
                </div>
                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("Total Range Distance")}{" "}
                  </label>
                  <InputNumber
                    disabled
                    min="0"
                    controls={false}
                    className="w-[350px]"
                    placeholder="0"
                    addonAfter={<div className="text-[#818181]">Km</div>}
                    defaultValue={vehicleDetail?.total_range_distance}
                    onChange={(event) => onChange("loadingTime", event)}
                  />
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:ACCIDENT_HISTORY_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <TextArea
                    style={{ height: 94, resize: "none" }}
                    className="mt-[8px]"
                    placeholder={t("VEHICLE_EDIT:ACCIDENT_HISTORY_PLACEHOLDER")}
                    defaultValue={vehicleDetail?.accident_history}
                    onChange={(event) =>
                      onChange("accidentHistory", event.target.value)
                    }
                  />
                </div>

                <div className="w-[500px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:LICENCE_PLATE_PHOTO_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <Dragger
                    selectedFileList={vehicleNumberImage}
                    setSelectedFileList={setVehicleNumberImage}
                  />
                </div>

                <div className="w-[500px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:PUC_NUMBER_PHOTO_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <Dragger
                    selectedFileList={vehiclePucImage}
                    setSelectedFileList={setVehiclePucImage}
                  />
                </div>

                <div className="w-[500px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:VEHICLE_INSURANCE_NUMBER_PHOTO")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <Dragger
                    selectedFileList={vehicleInsuranceImage}
                    setSelectedFileList={setVehicleInsuranceImage}
                  />
                </div>
              </div>
              <div className="flex flex-col gap-[16px]">
                <div className="flex gap-[6px] items-center">
                  <h3 className="font-roboto text-[18px] font-[500]">
                    {"Vehicle Specification"}
                  </h3>
                  <div
                    className="cursor-pointer"
                    onMouseEnter={() => setIsInfoOpened(true)}
                    onMouseLeave={() => setIsInfoOpened(false)}
                  >
                    <InformationIcon />
                  </div>
                  <div
                    className={`relative z-20 animate-popup delay-75 ${
                      isInfoOpened ? `visible` : `hidden`
                    }`}
                  >
                    <div className="w-[300px] h-auto rounded-[8px] bg-[#ECEDEE] shadow absolute top-[-10px] p-[8px]">
                      <p className="font-[500] text-[18px] text-[#424242]">
                        The values of the order unit, order weight, and order
                        volume depend on the parameter settings.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex gap-[16px]">
                  <div className="w-[242px]">
                    <label className="font-[500] text-[16px] text-[#000000]">
                      {t("VEHICLE_EDIT:MIN_ORDER_UNIT_FIELD")}
                    </label>
                    <InputNumber
                      controls={false}
                      className="w-[242px]"
                      style={
                        minOrderUnitError || minMoreThanMaxOrderUnitError
                          ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                          : {}
                      }
                      placeholder="0"
                      addonAfter={<div className="text-[#818181]">PCS</div>}
                      defaultValue={vehicleDetail.min_order_unit}
                      onChange={(event) => onChange("minOrderUnit", event)}
                    />
                    <p
                      className={`font-[12px] text-[#FF0000] font-roboto ${
                        minOrderUnitError ? `visible` : `hidden`
                      }`}
                    >
                      This field is required
                    </p>
                    <p
                      className={`font-[12px] text-[#FF0000] font-roboto ${
                        minMoreThanMaxOrderUnitError ? `visible` : `hidden`
                      }`}
                    >
                      Must be lower than the maximum value
                    </p>
                  </div>
                  <div className="w-[242px]">
                    <label className="font-[500] text-[16px] text-[#000000]">
                      {t("VEHICLE_EDIT:MAX_ORDER_UNIT_FIELD")}
                    </label>
                    <InputNumber
                      ref={maxOrderRef}
                      style={
                        maxOrderUnitError ||
                        parameterError ||
                        maxLessThanMinOrderUnitError
                          ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                          : {}
                      }
                      autoFocus={parameterError ? true : false}
                      controls={false}
                      className="w-[242px]"
                      placeholder="0"
                      addonAfter={<div className="text-[#818181]">PCS</div>}
                      defaultValue={vehicleDetail.max_order_unit}
                      onChange={(event) => onChange("maxOrderUnit", event)}
                    />
                    <p
                      className={`font-[12px] text-[#FF0000] font-roboto ${
                        maxOrderUnitError ? `visible` : `hidden`
                      }`}
                    >
                      This field is required
                    </p>
                    {/* <p className={`font-[12px] text-[#FF0000] font-roboto ${parameterError ? `visible` : `hidden`}`}>Max {maxOrder} PCS</p> */}
                    <p
                      className={`font-[12px] text-[#FF0000] font-roboto ${
                        maxLessThanMinOrderUnitError ? `visible` : `hidden`
                      }`}
                    >
                      Must be higher than the minimum value
                    </p>
                    {/* <p className={`font-[12px] text-[#818181] font-roboto ${!maxLessThanMinOrderUnitError && !maxOrderUnitError && !parameterError ? `visible` : `hidden`}`}>Max {maxOrder} PCS</p> */}
                  </div>
                </div>

                <div className="flex gap-[16px]">
                  <div className="w-[242px]">
                    <label className="font-[500] text-[16px] text-[#000000]">
                      {t("VEHICLE_EDIT:MIN_ORDER_WEIGHT_FIELD")}
                    </label>
                    <InputNumber
                      min="0"
                      controls={false}
                      className="w-[242px]"
                      style={
                        minOrderWeightError || minMoreThanMaxOrderWeightError
                          ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                          : {}
                      }
                      placeholder="0"
                      addonAfter={<div className="text-[#818181]">Kg</div>}
                      defaultValue={vehicleDetail.min_order_weight}
                      onChange={(event) => onChange("minOrderWeight", event)}
                    />
                    <p
                      className={`font-[12px] text-[#FF0000] font-roboto ${
                        minOrderWeightError ? `visible` : `hidden`
                      }`}
                    >
                      This field is required
                    </p>
                    <p
                      className={`font-[12px] text-[#FF0000] font-roboto ${
                        minMoreThanMaxOrderWeightError ? `visible` : `hidden`
                      }`}
                    >
                      Must be lower than the maximum value
                    </p>
                  </div>
                  <div className="w-[242px]">
                    <label className="font-[500] text-[16px] text-[#000000]">
                      {t("VEHICLE_EDIT:MAX_ORDER_WEIGHT_FIELD")}
                    </label>
                    <InputNumber
                      min="0"
                      controls={false}
                      className="w-[242px]"
                      style={
                        maxOrderWeightError || maxLessThanMinOrderWeightError
                          ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                          : {}
                      }
                      placeholder="0"
                      addonAfter={<div className="text-[#818181]">Kg</div>}
                      defaultValue={vehicleDetail.max_order_weight}
                      onChange={(event) => onChange("maxOrderWeight", event)}
                    />
                    <p
                      className={`font-[12px] text-[#FF0000] font-roboto ${
                        maxOrderWeightError ? `visible` : `hidden`
                      }`}
                    >
                      This field is required
                    </p>
                    <p
                      className={`font-[12px] text-[#FF0000] font-roboto ${
                        maxLessThanMinOrderWeightError ? `visible` : `hidden`
                      }`}
                    >
                      Must be lower than the maximum value
                    </p>
                  </div>
                </div>

                <div className="flex gap-[16px]">
                  <div className="w-[242px]">
                    <label className="font-[500] text-[16px] text-[#000000]">
                      {t("VEHICLE_EDIT:MIN_ORDER_VOLUME_FIELD")}
                    </label>
                    <InputNumber
                      min="0"
                      controls={false}
                      className="w-[242px]"
                      style={
                        minOrderVolumeError || minMoreThanMaxOrderVolumeError
                          ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                          : {}
                      }
                      placeholder="0"
                      addonAfter={<div className="text-[#818181]">m³</div>}
                      defaultValue={vehicleDetail.min_order_volume}
                      onChange={(event) => onChange("minOrderVolume", event)}
                    />
                    <p
                      className={`font-[12px] text-[#FF0000] font-roboto ${
                        minOrderVolumeError ? `visible` : `hidden`
                      }`}
                    >
                      This field is required
                    </p>
                    <p
                      className={`font-[12px] text-[#FF0000] font-roboto ${
                        minMoreThanMaxOrderVolumeError ? `visible` : `hidden`
                      }`}
                    >
                      Must be lower than the maximum value
                    </p>
                  </div>
                  <div className="w-[242px]">
                    <label className="font-[500] text-[16px] text-[#000000]">
                      {t("VEHICLE_EDIT:MAX_ORDER_VOLUME_FIELD")}
                    </label>
                    <InputNumber
                      min="0"
                      controls={false}
                      className="w-[242px]"
                      style={
                        maxOrderVolumeError || maxLessThanMinOrderVolumeError
                          ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                          : {}
                      }
                      placeholder="0"
                      addonAfter={<div className="text-[#818181]">m³</div>}
                      defaultValue={vehicleDetail.max_order_volume}
                      onChange={(event) => onChange("maxOrderVolume", event)}
                    />
                    <p
                      className={`font-[12px] text-[#FF0000] font-roboto ${
                        maxOrderVolumeError ? `visible` : `hidden`
                      }`}
                    >
                      This field is required
                    </p>
                    <p
                      className={`font-[12px] text-[#FF0000] font-roboto ${
                        maxLessThanMinOrderVolumeError ? `visible` : `hidden`
                      }`}
                    >
                      Must be higher than the minimum value
                    </p>
                  </div>
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:FIX_COST_FIELD")}
                  </label>
                  <InputNumber
                    min="0"
                    controls={false}
                    className="w-[350px]"
                    placeholder={t("VEHICLE_EDIT:FIX_COST_PLACEHOLDER")}
                    style={
                      fixedCostError
                        ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                        : {}
                    }
                    addonBefore={<div className="text-[#818181]">IDR</div>}
                    defaultValue={vehicleDetail.fixed_cost}
                    onChange={(event) => onChange("fixCost", event)}
                  />
                  <p
                    className={`font-[12px] text-[#FF0000] font-roboto ${
                      fixedCostError ? `visible` : `hidden`
                    }`}
                  >
                    This field is required
                  </p>
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:VARIABLE_COST_PER_KM_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <InputNumber
                    min="0"
                    controls={false}
                    className="w-[350px]"
                    placeholder={t(
                      "VEHICLE_EDIT:VARIABLE_COST_PER_KM_PLACEHOLDER"
                    )}
                    addonBefore={<div className="text-[#818181]">IDR</div>}
                    defaultValue={vehicleDetail.variable_cost}
                    onChange={(event) => onChange("variableCost", event)}
                  />
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:TRANSPORTER_TIME_COST_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <InputNumber
                    min="0"
                    controls={false}
                    className="w-[350px]"
                    placeholder={t(
                      "VEHICLE_EDIT:TRANSPORTER_TIME_COST_PLACEHOLDER"
                    )}
                    addonBefore={<div className="text-[#818181]">IDR</div>}
                    defaultValue={vehicleDetail.transporter_time_cost}
                    onChange={(event) => onChange("transporterTimeCost", event)}
                  />
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:WAITING_TIME_COST_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <InputNumber
                    min="0"
                    controls={false}
                    className="w-[350px]"
                    placeholder={t(
                      "VEHICLE_EDIT:WAITING_TIME_COST_PLACEHOLDER"
                    )}
                    addonBefore={<div className="text-[#818181]">IDR</div>}
                    defaultValue={vehicleDetail.waiting_time_cost}
                    onChange={(event) => onChange("waitingTimeCost", event)}
                  />
                </div>

                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {t("VEHICLE_EDIT:LOADING_TIME_FIELD")}{" "}
                    <i>{t("VEHICLE_EDIT:OPTIONAL_TAG")}</i>
                  </label>
                  <InputNumber
                    min="0"
                    controls={false}
                    className="w-[350px]"
                    placeholder="0"
                    addonAfter={<div className="text-[#818181]">Min</div>}
                    defaultValue={vehicleDetail.loading_time}
                    onChange={(event) => onChange("loadingTime", event)}
                  />
                </div>

                {vehicleDetail.additional_proofs?.map((item) => {
                  return (
                    <div className="w-[350px] flex flex-col gap-[8px]">
                      <label className="font-[500] text-[16px] text-[#000000]">
                        {item.additional_proofs_name}{" "}
                        <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                      </label>
                      <Input
                        className="mt-[8px] w-[350px]"
                        placeholder={item.description}
                        onChange={(event) =>
                          additionalProofEditOnChange(item, event.target.value)
                        }
                        defaultValue={item.value}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="flex flex-row-reverse gap-[16px]">
            <PrimaryButton
              text={t("VEHICLE_EDIT:SAVE")}
              action={() => handleSubmit(vehicleDetail)}
            />
            <SecondaryButton
              text={t("VEHICLE_EDIT:CANCEL")}
              action={() => checkIsEdited()}
            />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
